import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchInvitedActivityById = createAsyncThunk('getInvitedActivityId/fetchInvitedActivityById',
  async (id, { rejectWithValue }) => {
    try {
      const url = `${api.getInvitedActivity}${id}`;
      const cleanId = String(url).replaceAll(/"/g, '').trim();
      const response = await axiosPrivate.get(cleanId)
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server")
    }
  })

const getInvitedActivitySlice = createSlice({
  name: 'ActivityList',
  initialState: {
    ActivityList: [],
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchInvitedActivityById.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchInvitedActivityById.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.ActivityList = action.payload;
        })
      .addCase(fetchInvitedActivityById.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        });
  }
})

export default getInvitedActivitySlice.reducer;